import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { SignupService } from "../services/signup.service";


@Injectable()
export class OrgIDResolve implements Resolve<any> {

  constructor(private signupService: SignupService) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let orgid = route.params['orgid']
    if (orgid == null) {
      return null;
    }

    return new Promise<any>((resolve, reject) => {
      this.signupService.validateOrgID(orgid).subscribe(
        (data) => {
          if (!data)
            reject(data);
          else
            resolve(data);
        });
    }).then(function (data) {
      return data;
    }, function (data) {
      window.location.replace("/signup");
      return data;
    });

  }

}
